class QuickPredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('keydown', (event) => {
          if (event.keyCode === 13) {
              event.preventDefault();
          }
      });
      this.bindEvents();
      this.bindQuickAdd();
      document.querySelector('[data-add-new-line]')?.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('quick-predictive-search form').classList.remove('d-none');
      });
    }
    
    
  
    bindEvents(){
      let productsList = document.querySelectorAll('#predictive-search-results .list-item');
      if(!productsList.length) {
        if (document.querySelector('#predictive-search-results')) {
          document.querySelector('#predictive-search-results').innerHTML = `
                <ul role="listbox" aria-labelledby="predictive-search-products" class="quick-predictive-search-empty list-unstyled">
                    <li class="list-item col d-flex mx-3 pb-2"> No Result Found !</li>
                </ul>`
        }
      }
      productsList.forEach(el => {
        el.addEventListener('click', async (event) => {
          event.stopImmediatePropagation();
          event.preventDefault();
          let productHandle = event.target.closest('.list-item').getAttribute('data-quick-item-handle');
          const product = await this._getProductFromHandle(productHandle)
          const variant_id = event.target.closest('[data-quick-variant-id]').getAttribute('data-quick-variant-id');
          this.variant = product.variants.find((item) => item.id == variant_id);
          this.max_qty = event.target.closest('[data-max-qty]')?.getAttribute('data-max-qty') || '';
          document.querySelector('.quick-order-form-search').value = this.variant.sku;
          if (document.querySelector('quick-predictive-search [name="quantity"]')) {
            document.querySelector('quick-predictive-search [name="quantity"]').setAttribute('max',this.max_qty);
            document.querySelector('quick-predictive-search [name="quantity"]').value = 1;
          }
          if(this.variant){
            document.querySelector('[data-quick-search-add]')?.classList.remove('disabled');
          }
          this.close();
        });
      });
      
    }

    bindQuickAdd(){
      document.querySelector('[data-quick-search-add]')?.addEventListener('click', (event)=> {
        event.preventDefault();
        const body = JSON.stringify({
          items: [{ id: this.variant.id, quantity: document.querySelector('quick-predictive-search [name="quantity"]').value, properties: { '_quick_search': true }}]
        });
        event.target?.closest('.btn')?.classList.add('loading');
        fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
        .then((response)=>{
          return response.json();
        })
        .then((data)=>{
          event.target?.classList.remove('loading');
          document.querySelector('cart-form').getCartData();
        });
      })
    }

    async _getProductFromHandle(handle){
      const response = await fetch(`/products/${handle}.js`);
      const data = await response.json();
      if(response.ok){
        return data;
      } else {
        window.notificationEle.updateNotification('Something went wrong', 'Please try again later', {
          type: 'error',
          timeout: 5000
        });
      }
     
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.sku,variants.title&section_id=quick-predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          this.predictiveSearchResults.innerHTML = '';
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-quick-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.highlightMatchingProduct(searchTerm);
          this.open();
          this.bindEvents();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
    
    highlightMatchingProduct(searchTerm) {
      const listItems = this.predictiveSearchResults.querySelectorAll('.list-item'); // Assuming search results are within .list-item
      
      listItems.forEach(item => {
        const productTitleElement = item.querySelector('.predictive-search__item-content'); // Modify based on your markup
        const productTitleText = productTitleElement.textContent.trim();
        const searchTermLower = searchTerm.toLowerCase();
        
        if (productTitleElement && productTitleText.toLowerCase().includes(searchTermLower)) {
          // Create a regex to find and wrap the search term
          const regex = new RegExp(`(${searchTerm})`, 'gi');
          // Replace the original text with the highlighted text
          productTitleElement.innerHTML = productTitleText.replace(regex, '<span class="text-blue-1 text-primary fw-semibold">$1</span>');
        } else {
          // Reset the original text if there's no match (optional)
          productTitleElement.innerHTML = productTitleText;
        }
      });
    }
    
    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.input.classList.add('active')
    }
    
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.input.classList.remove('active')
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
customElements.define('quick-predictive-search', QuickPredictiveSearch);